module.exports = __webpack_public_path__ + "static/img/ER.c2311144.png";